import React, { useEffect, useRef } from 'react'

import Section from '../../../../../../components/Section'

type Props = {
    theme: string
    purchaseGuid: string
    annotationPurchase: string | null
    onAnnotationPurchaseChange: (value: string | null) => void
}

const PurchaseCardAnnotation: React.FC<Props> = (props) => {
    const isChangedByUser = useRef(false)

    const updatePurchase = async (updatedField: Record<string, unknown>) => {
        try {
            const response = await fetch(
                process.env.REACT_APP_API_URL +
                    '/api/backend/v1/purchase/' +
                    encodeURIComponent(props.purchaseGuid),
                {
                    method: 'PUT',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(updatedField),
                }
            )

            if (!response.ok) {
                throw new Error('Ошибка обновления данных в базе')
            }
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(() => {
        // Значение изменилось не из-за ввода пользователя:
        // например, данные загрузились с backend
        if (!isChangedByUser.current) {
            return
        }

        const timeoutId = window.setTimeout(() => {
            updatePurchase({
                annotation: props.annotationPurchase || null,
            })

            isChangedByUser.current = false
        }, 2000)

        return () => {
            window.clearTimeout(timeoutId)
        }
    }, [props.annotationPurchase])

    const handleAnnotationChange = (value: string) => {
        isChangedByUser.current = true
        props.onAnnotationPurchaseChange(value || null)
    }

    return (
        <Section title="Примечание к закупке">
            <div className="flex flex-col w-full gap-x-5 mt-2">
                <div className="flex flex-col min-w-[200px]">
                    <label className="mb-1 text-sm text-[#6A6A6A] dark:text-[#8A8A8A]">
                        Примечание
                    </label>

                    <textarea
                        className="form-textarea"
                        maxLength={2000}
                        rows={3}
                        value={props.annotationPurchase || ''}
                        onChange={(e) => handleAnnotationChange(e.target.value)}
                    />
                </div>
            </div>
        </Section>
    )
}

export default PurchaseCardAnnotation
